import { render, staticRenderFns } from "./StudentPasswordReminder.vue?vue&type=template&id=5c89d00c&scoped=true&lang=pug&"
import script from "./StudentPasswordReminder.vue?vue&type=script&lang=ts&"
export * from "./StudentPasswordReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89d00c",
  null
  
)

export default component.exports